import { Injectable } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private currentPagePath: string = '';

  constructor(private analytics: Analytics, private router: Router) {
    this.trackPageViews();
  }

  private trackPageViews(): void {
    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentPagePath = event.urlAfterRedirects || event.url;
        logEvent(this.analytics, 'page_view', {
          page_path: this.currentPagePath,
        });
      });
  }

  logButtonClick(buttonId: string, pageName: string): void {
    console.log(`Logging button click: buttonId=${buttonId}, pageName=${pageName}`);
    logEvent(this.analytics, 'button_click', {
      button_id: buttonId,
      page_name: this.currentPagePath || pageName
    });
    console.log('logEvent called successfully');
  }
}